import React from "react";
import TextEditor from "../../../components/common/TextEditor";
import Modal from "../../../components/common/Modal";
import { useForm } from "react-hook-form";
import Button from "../../../components/common/Button";
import _ from "lodash";

type Inputs = {
  telescript: string;
};

const TELESCRIPT_REQUIRED_MESSAGE = "Please add teleprompter script";

const isTelescriptEmpty = (html: string): boolean => {
  const t = (html || "").trim();
  if (!t) return true;
  if (t === "<p></p>") return true;
  return false;
};

const ScriptEditorModal = (props) => {
  const {
    register,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm<Inputs>();

  const teleField = register("telescript");
  /** TextEditor only attaches `ref` — pass `.ref`, not full register() result */
  const telescriptInputRef = teleField.ref;

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    clearErrors("telescript");
    const raw = new FormData(e.currentTarget).get("telescript");
    const html = typeof raw === "string" ? raw : "";

    if (isTelescriptEmpty(html)) {
      setError("telescript", {
        type: "required",
        message: TELESCRIPT_REQUIRED_MESSAGE,
      });
      return;
    }

    if (typeof props.onSubmit === "function") {
      props.onSubmit(html);
    }
  };

  return (
    <Modal
      visible={props.status}
      size="large"
      className="tele-script-modal"
      closeButton={true}
      closeButtonCross={true}
      onClose={() => props.handleOnClose()}
    >
      <form
        className="text-editor-form"
        noValidate
        onSubmit={handleFormSubmit}
      >
        <TextEditor
          defaultValue={_.get(props, "value", "")}
          name="telescript"
          className="tele-script"
          placeholder="Add your teleprompter script"
          validationObj={errors}
          inputRef={telescriptInputRef}
        />
        <div className="submit-btn-container">
          <Button type="submit" className="primary-btn">
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ScriptEditorModal;
